// extracted by mini-css-extract-plugin
export default {"container":"upload-box_container__2afhh"};